import { SessionInterface, UserInterface, UserSession } from "@/interface/user.interface.ts";
import { UserType } from "@/types/user.type";

// import ability from "@/services/ability";
/**
 * @example const session = new SessionModel(response);
 * @readonly {token, id, email, first_name, last_name, permissions}
 * @public getUser(): Object
 * @public getToken(): String
 * @public getPermissions(): any[]
 */
export class SessionModel implements UserSession {
  readonly token: string = "";
  readonly id: string = "";
  readonly email: string = "";
  readonly first_name: string = "";
  readonly last_name: string = "";
  readonly permissions: any[] = [];
  readonly is_agent: boolean = false;

  constructor(response: SessionInterface) {
    this.id = response.user?.id || "";
    this.token = response?.token || "";
    this.email = response?.user?.email || "";
    this.first_name = response?.user?.first_name || "";
    this.last_name = response?.user?.last_name || "";
    this.permissions = response?.user?.permissions || [];
    this.is_agent = response?.user?.is_agent;

    //TODO: Delete this code
    if (this.is_agent && this.permissions.findIndex((i) => i.includes("customers.customer")) !== -1) {
      this.permissions.push("customers.customer.create");
      this.permissions.push("customers.customer.delete");
      this.permissions.push("customers.customer.export");
      this.permissions.push("customers.customer.import");
      this.permissions.push("customers.customer.read");
      this.permissions.push("customers.customer.update");
    }
  }

  public getUser(): Object {
    return {
      id: this.id,
      email: this.email,
      first_name: this.first_name,
      last_name: this.last_name,
      is_agent: this.is_agent,
    };
  }

  public getFullName(): string {
    return `${this.first_name} ${this.last_name}`;
  }

  public getToken(): String {
    return this.token;
  }

  public getPermissions(): any {
    let groups = {};
    this.permissions.map((value) => {
      const item = value.split(".");

      const key = `${item[0]}/${item[1]}`;
      const ab = item[2];
      let able = [ab];

      if (groups[key]) able = [...groups[key], ab];

      groups[key] = able;
    });
    // return this.permissions;
    return groups;
  }
}

export class UserModel implements UserInterface {
  readonly id: string = "";
  readonly sub_domain: string = "";
  readonly first_name: string = "";
  readonly last_name: string = "";
  readonly email: string = "";
  readonly is_owner: boolean = false;
  readonly is_staff: boolean = false;
  readonly is_agent: boolean = false;
  readonly is_active: boolean = false;
  readonly is_terminal: boolean = false;
  readonly last_login: Date = new Date();
  readonly created_at: Date = new Date();
  readonly updated_at: Date = new Date();
  readonly permissions: Array<any> = [];
  readonly locations: any[] = [];
  readonly selected: boolean = false;

  constructor(response: UserType) {
    this.id = response.id || "";
    this.sub_domain = response.sub_domain = "";
    this.first_name = response.first_name || "";
    this.last_name = response.last_name || "";
    this.email = response.email;
    this.is_owner = response.is_owner = false;
    this.is_staff = response.is_staff = false;
    this.is_agent = response.is_agent;
    this.is_active = response.is_active = false;
    this.is_terminal = response.is_terminal = false;
    this.last_login = response.last_login = new Date();
    this.created_at = response.created_at = new Date();
    this.updated_at = response.updated_at = new Date();
    this.permissions = response.permissions || [];
    this.locations = response.locations = [];
  }

  public getFullName(): string {
    return `${this.first_name} ${this.last_name}`;
  }
}
